import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { ShipperOptionsResponse } from 'src/entities/Report.entity';

// 実運送体制管理簿専用の荷主候補。帳票本体と同じ基準（Search＋配車済）で荷主を返すため、
// operation を持たない手動配車の荷主も候補に出る。商品別コースリスト用の
// useShipperOptionsQuery（/api/v5/reports/shippers, ShiftTruck.start_at 起点）とは別。
const requestPath = '/api/v5/reports/transport_system_ledger_shippers';
const queryPrefix = 'useTransportSystemLedgerShipperOptionsQuery';

type Params = {
  startOn: string;
  endOn: string;
  enabled?: boolean;
};

const fetchShippers = ({ startOn, endOn }: Params) => async () => {
  const response = await axios.get<ShipperOptionsResponse>(requestPath, {
    params: { start_on: startOn, end_on: endOn },
  });
  return response.data;
};

export const useTransportSystemLedgerShipperOptionsQuery = ({ startOn, endOn, enabled = true }: Params) => useQuery(
  [queryPrefix, { startOn, endOn }],
  fetchShippers({ startOn, endOn }),
  {
    // 配車状況は手動配車等で動的に変わるため、ダイアログを開くたびに最新候補を取得する（staleTime 既定 0）
    enabled: enabled && Boolean(startOn) && Boolean(endOn),
  },
);
